import { render, staticRenderFns } from "./AverageHotel.vue?vue&type=template&id=74e3b707"
import script from "./AverageHotel.vue?vue&type=script&lang=js"
export * from "./AverageHotel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports